"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var HttpFunctions = require("./http.functions");
var retry_strategy_1 = require("./retry-strategy");
var HttpService = /** @class */ (function () {
    function HttpService() {
    }
    HttpService.prototype.get = function (call, options) {
        // bind callback from axios promise
        var axiosObservable = rxjs_1.bindCallback(HttpFunctions.getCallback);
        // map axios observable
        return this.mapAxiosObservable(axiosObservable, call, options);
    };
    HttpService.prototype.post = function (call, options) {
        // bind callback from axios promise
        var axiosObservable = rxjs_1.bindCallback(HttpFunctions.postCallback);
        // map axios observable
        return this.mapAxiosObservable(axiosObservable, call, options);
    };
    HttpService.prototype.put = function (call, options) {
        // bind callback from axios promise
        var axiosObservable = rxjs_1.bindCallback(HttpFunctions.putCallback);
        // map axios observable
        return this.mapAxiosObservable(axiosObservable, call, options);
    };
    HttpService.prototype.delete = function (call, options) {
        // bind callback from axios promise
        var axiosObservable = rxjs_1.bindCallback(HttpFunctions.deleteCallback);
        // map axios observable
        return this.mapAxiosObservable(axiosObservable, call, options);
    };
    HttpService.prototype.mapAxiosObservable = function (axiosObservable, call, options) {
        var _this = this;
        return axiosObservable(call, options).pipe(operators_1.retryWhen(retry_strategy_1.retryStrategy.strategy({
            maxRetryAttempts: options && options.maxRetryAttempts ? options.maxRetryAttempts : 0,
            useRetryForResponseCodes: options && options.useRetryForResponseCodes
                ? options.useRetryForResponseCodes
                : []
        })), operators_1.map(function (result) { return _this.mapResult(result); }), operators_1.catchError(function (error) {
            // Handling errors: https://github.com/axios/axios#handling-errors
            if (options && options.logErrorToConsole) {
                console.warn("Kentico Cloud SDK encountered an error posting data: ", error);
            }
            return rxjs_1.throwError({
                originalError: error,
                mappedError: call.mapError(error)
            });
        }));
    };
    HttpService.prototype.mapResult = function (result) {
        // if error is set, throw it
        if (result.error) {
            throw result.error;
        }
        // if neither error nor response is set, throw an error
        if (!result.response) {
            throw Error('Response is not set and no error was thrown');
        }
        return {
            data: result.response.data,
            response: result.response
        };
    };
    return HttpService;
}());
exports.HttpService = HttpService;
//# sourceMappingURL=http.service.js.map